export interface LocationsPageUrlState {
  search: string;
  city: string | null;
  /** 1-based page number for the URL; omitted from query when 1. */
  page: number;
}

export const EMPTY_LOCATIONS_PAGE_URL_STATE: LocationsPageUrlState = {
  search: "",
  city: null,
  page: 1,
};

export const LOCATIONS_PAGE_SIZE = 10;

function parsePage(value: string | null): number {
  if (value == null || value.trim() === "") return 1;
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
}

function parseOptionalString(value: string | null): string | null {
  const trimmed = value?.trim() ?? "";
  return trimmed ? trimmed : null;
}

export function locationsPageUrlStateEqual(
  a: LocationsPageUrlState,
  b: LocationsPageUrlState,
): boolean {
  return a.search === b.search && a.city === b.city && a.page === b.page;
}

export function parseLocationsPageParamsFromSearchParams(
  searchParams: URLSearchParams,
): LocationsPageUrlState {
  return {
    search: searchParams.get("q")?.trim() ?? "",
    city: parseOptionalString(searchParams.get("city")),
    page: parsePage(searchParams.get("page")),
  };
}

export function buildLocationsPageQuery(state: LocationsPageUrlState): string {
  const params = new URLSearchParams();

  if (state.search.trim()) {
    params.set("q", state.search.trim());
  }
  if (state.city) {
    params.set("city", state.city);
  }
  if (state.page > 1) {
    params.set("page", String(state.page));
  }

  const query = params.toString();
  return query ? `?${query}` : "";
}

export function locationsPageParamsMatchSearchParams(
  state: LocationsPageUrlState,
  searchParams: URLSearchParams,
): boolean {
  return locationsPageUrlStateEqual(
    state,
    parseLocationsPageParamsFromSearchParams(searchParams),
  );
}
